import { useEffect } from "react";
import { PageHero } from "@/components/PageHero";
import { ContactSection } from "@/components/ContactSection";
import { BUSINESS } from "@/data/site";

export default function Contact() {
  useEffect(() => { document.title = `Contact — ${BUSINESS.name}`; }, []);
  return (
    <>
      <PageHero
        overline="Contact"
        titleLines={["Let's build", "something extraordinary."]}
        subtitle="Tell us about your project and we'll get back within 24 hours with a free custom mockup and a tailored proposal."
      />
      <ContactSection withHeading={false} />
    </>
  );
}
